export default class Author {
	constructor (init = {}) {
		this.name = init.hasOwnProperty('name') ? init.name : ''
		this.position = init.hasOwnProperty('position') ? init.position : ''
		this.photo = init.hasOwnProperty('photo') ? init.photo : ''
		this.isOpenTab = true
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/Author.js